import { useState } from 'react';
import { plugin, debug } from 'light-component';
import { lang } from 'zf-infra';
import { convert, TreeService, useTranslation } from '@common';
import * as Base from '@base';
import { Require } from '../component';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { TreeSelectProps } from './types';

export function WidgetTreeSelect(props: TreeSelectProps): ReactElement {
  debug.widget('dashboard TreeSelect', props);

  const [selected, setSelected] = useState<string | undefined>(props.value?.[0] ?? undefined);
  const [t] = useTranslation();

  const treeData = props.options?.map(item => ({
    icon: item.groupType === 'area' ? convert('AreaSvgIcon') : convert('StoreSvgIcon'),
    ...item
  }));

  // 返回所选组织下所有门店【】 / 【组织自身】
  const onChange = (groupId: string): void => {
    if (props.options?.length === 0) {
      return;
    }
    const stores = props.options
      .filter(item => item.groupType === 'store' && (lang.intersection(item.idPath, [groupId]).length > 0))
      .map(item => item._id);

    setSelected(groupId);

    // 组织筛选，有些接口需要selectedArea参数， 采用emitter形式传递
    props?.emitter?.trigger('VARIABLE_CHANGE', [groupId], { uid: 'SelectedArea' });
    props.onChange?.(stores.length > 0 ? stores : undefined);
  };

  return (
    <div className={props.className}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <Base.TreeSelect
        className={styles.treeSelect}
        treeIcon
        value={selected}
        placeholder={t('请选择组织')}
        showSearch
        allowClear
        autoClearSearchValue
        size='middle'
        treeNodeFilterProp='title'
        treeDefaultExpandedKeys={[props.options?.find(item => item.parent === '')?._id ?? '']}
        treeLine={{ showLeafIcon: false }}
        popupMatchSelectWidth={false}
        treeData={new TreeService().toTree(treeData ?? [])}
        onChange={onChange}
      />
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'tree', component: WidgetTreeSelect });
